import { Variants } from "framer-motion";

export const VARIANTS: Variants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
  },
};
